/* eslint-disable no-empty */
import Vue from 'vue'
import Vuex from 'vuex'
import VueSimpleAlert from "vue-simple-alert";

import VuexPersist from 'vuex-persist';
import * as getters from './store/getters/ModuloGetters'
import * as mutations from './store/mutations/ModuloMutations'
import * as actions from './store/actions/ModuloActions'

Vue.use(VueSimpleAlert);
Vue.use(Vuex)

// manejo de sesión persistente
const vuexLocalStorage = new VuexPersist({
    key: 'store', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    reducer: state => ({loggingIn: state.loggingIn}),
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    // filter: mutation => (true)
})


export const store = new Vuex.Store({
    plugins: [vuexLocalStorage.plugin],
    state: {
        showSpinner: false,
        spinnerIcon: "loading",
        spinnerMessage: "",
        token: null,
        sidebarShow: 'responsive',
        sidebarMinimize: false,
        loggingIn: false,
        loginError: null,
        loginSuccessful: false,
        dataResponse: [],
        showModal: false,
        configModal: [{
            color: "danger",
            contenido: "Error en ejecución ",
            boton: "Aceptar",
            titulo: ""

        }],
        Loading: false,
        imgEmpleado: {
            default: './img/logo_latino_azul.png'
        },
        flagResponse: false,
        config: {}
    },
    getters,
    actions,
    mutations,
    modules: {

    }
})

export default store